import { render, staticRenderFns } from "./item-renderer.mpx?vue&type=template&id=6cc35140&isComponent&outputPath=components%2Fitem-renderer021f3bba%2Findex"
import script from "./item-renderer.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fitem-renderer021f3bba%2Findex"
export * from "./item-renderer.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fitem-renderer021f3bba%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports